const BoxChart = ({ data, setStatus }) => {
  // Define config once
  const stats = [
    {
      status: "exploitable",
      label: "Exploitable Vulnerabilities",
      value: data?.exploitable_vuln_count,
      color: "text-red-500",
    },
    {
      status: "high_risk",
      label: "High Risk Vulnerabilities",
      value: data?.high_risk_count,
      color: "text-red-500",
    },
    {
      status: "resolved",
      label: "Resolved Vulnerabilities",
      value: data?.resolved_vuln_count,
      color: "text-green-500",
    },
    {
      status: "accepted",
      label: "Accepted Vulnerabilities",
      value: data?.accepted_vuln_count,
      color: "text-[#29C2E4]",
    },
    {
      status: "pending",
      label: "Unresolved Vulnerabilities",
      value: data?.pending_vuln_count,
      color: "text-red-500",
    },
    {
      status: "total",
      label: "Total Vulnerabilities",
      value: data?.total_vuln_detected,
      color: "text-amber-600",
    },
  ];

  const StatCard = ({ label, value, color, status }) => {
    return (
      <div
        className="border-[3px] border-secondary200 rounded-lg p-[1px] cursor-pointer"
        onClick={() => setStatus(status)}
      >
        <div className="w-full border-2 border-dashed border-[#71788450] rounded-lg p-3 h-full flex flex-col justify-between">
          <p className="text-sm font-medium text-gray-400 mb-3 pr-10">
            {label}
          </p>
          <p className={`text-[28px] font-semibold leading-none ${color}`}>
            {value ?? 0}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="grid xl:grid-cols-6 md:grid-cols-3 gap-4 w-full">
      {stats.map((item, i) => (
        <StatCard
          key={i}
          label={item?.label}
          value={item?.value}
          color={item?.color}
          status={item?.status}
        />
      ))}
    </div>
  );
};

export default BoxChart;
